/**
 * Cómo se le cuenta al usuario de dónde salieron los números.
 *
 * Más allá de la retención cruda el panel deja de leer span por span y pasa a
 * leer totales diarios. Los conteos siguen siendo exactos, pero los
 * percentiles se calculan distinto y las ejecuciones individuales ya no
 * existen. Callarlo sería la peor opción: alguien compararía el p95 de ayer
 * contra el de marzo, vería una diferencia de un par de puntos y saldría a
 * buscar una regresión que no ocurrió.
 *
 * En un módulo sin JSX porque es una regla, no una vista, y así se puede
 * probar con el ejecutor de Node.
 */

export type Fuente = 'crudo' | 'diario';

export interface AvisoFuente {
  titulo: string;
  detalle: string;
}

export function avisoDeFuente(fuente: Fuente | undefined): AvisoFuente | null {
  if (fuente !== 'diario') return null;
  return {
    titulo: 'Datos agregados por día',
    detalle:
      'La ventana excede lo que se guarda ejecución por ejecución. Los totales son exactos; ' +
      'los percentiles son aproximados y los bordes se redondean a días completos.',
  };
}

/** Si la fuente agregada explica que no haya ejecuciones para abrir. */
export function ejemplosDisponibles(fuente: Fuente | undefined): boolean {
  return fuente !== 'diario';
}
